import * as constants from './constants';
import { fromJS } from 'immutable';


const defaultState = fromJS({
	menu: [
		{
			"id": 1,
			"pid": 0,
			"name": "大盘统计",
			"key_name": "dashboard",
			"link_to": "/dashboard",
			"external_link": "#",
			"target_type": 1,
			"icon": "",
			"order_num": 1,
			"children": [],
		},
		{
			"id": 2,
			"pid": 0,
			"name": "任务管理",
			"key_name": "builder",
			"link_to": "",
			"external_link": "#",
			"target_type": 1,
			"icon": "",
			"order_num": 2,
			"children": [
				{
					"id": 3,
					"pid": 2,
					"name": "任务列表",
					"key_name": "builder_list",
					"link_to": "/builder/list",
					"external_link": "#",
					"target_type": 1,
					"icon": "",
					"order_num": 3,
					"children": [],
				},
				{
					"id": 4,
					"pid": 2,
					"name": "任务添加",
					"key_name": "builder_add",
					"link_to": "/builder/add",
					"external_link": "#",
					"target_type": 1,
					"icon": "",
					"order_num": 4,
					"children": [],
				},
			],
		},
		{
			"id": 5,
			"pid": 0,
			"name": "权限管理",
			"key_name": "privilege",
			"link_to": "",
			"external_link": "#",
			"target_type": 1,
			"icon": "",
			"order_num": 5,
			"children": [
				{
					"id": 6,
					"pid": 5,
					"name": "权限列表",
					"key_name": "privilege_list",
					"link_to": "/privilege",
					"external_link": "#",
					"target_type": 1,
					"icon": "",
					"order_num": 6,
					"children": [],
				},
				{
					"id": 7,
					"pid": 5,
					"name": "权限添加",
					"key_name": "privilege_add",
					"link_to": "",
					"external_link": "#",
					"target_type": 1,
					"icon": "",
					"order_num": 7,
					"children": [
						{
							"id": 8,
							"pid": 7,
							"name": "权限子子",
							"key_name": "privilege_son",
							"link_to": "/privilege/son",
							"external_link": "#",
							"target_type": 1,
							"icon": "",
							"order_num": 8,
							"children": [],
						},
						{
							"id": 9,
							"pid": 7,
							"name": "权限孙孙",
							"key_name": "privilege_grandson",
							"link_to": "/privilege/grandson",
							"external_link": "#",
							"target_type": 1,
							"icon": "",
							"order_num": 9,
							"children": [],
						}
					],
				},
			],
		},
	],
});

const stateAction = (state = defaultState, action) => {
	switch(action.type) {
		case constants.CHANGE_MENU:
			return state.merge({menu: fromJS(action.menu)});
		default:
			return state;
	}
}

export default stateAction;